import { useLoader } from '@/contexts/LoaderContext';

export default function GlobalLoader() {
  const { isLoading } = useLoader();

  if (!isLoading) return null;

  return (
    <>
      <div className="loader-overlay">
        <div className="loader-container">
          <div className="loader-spinner"></div>
          <p className="loader-text">Loading...</p>
        </div>
      </div>
      
      <style jsx>{`
        .loader-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background: rgba(0, 0, 0, 0.7);
          backdrop-filter: blur(5px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
        }
        
        .loader-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 1.5rem;
          background: rgba(255, 255, 255, 0.1);
          padding: 2rem;
          border-radius: 15px;
          border: 1px solid rgba(255, 255, 255, 0.2);
        }
        
        .loader-spinner {
          width: 50px;
          height: 50px;
          border: 4px solid rgba(244, 196, 48, 0.3);
          border-top: 4px solid #f4c430;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }
        
        .loader-text {
          color: #f4c430;
          font-size: 1.1rem;
          font-weight: 500;
          margin: 0;
        }
        
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        @media (max-width: 768px) {
          .loader-container {
            padding: 1.5rem;
          }
          
          .loader-spinner {
            width: 40px;
            height: 40px;
          }
          
          .loader-text {
            font-size: 1rem;
          }
        }
      `}</style>
    </>
  );
}